import { Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { constants } from '@hero/configs';

const ListContainer = styled.div`
  display: grid;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  margin-bottom: 16px;

  ${() => {
    return css`
      grid-template-columns: repeat(auto-fill, minmax(${constants?.products?.card?.width}, 1fr));
    `;
  }}
`;

const ProductCardWrapper = styled.div``;

const ProductList = styled.div``;

const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  width: 100%;
`;

const EmptyStateDescription = styled(Typography)`
  margin: 24px auto;
  max-width: 330px;
`;

export { EmptyStateDescription, EmptyStateWrapper, ListContainer, ProductCardWrapper, ProductList };
